import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserIndexComponent } from './index';
import { CanActivateGuard } from './../shared/index';
//import { CatalogResolve } from "./index";

export const UserRoutes: Routes = [
    {
        path: 'user',
        component: UserIndexComponent,
        canActivate: [CanActivateGuard]
    }
];

export const UserRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(UserRoutes);
